var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',_vm._b({staticStyle:{"margin":"-3px !important","padding":"0 !important","text-align":"center !important"},on:{"change":function($event){return _vm.$emit('input',$event)}},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'v-checkbox',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }